module.exports = __webpack_public_path__ + "img/6.ecc4c69a.png";